import React from 'react';
import { X } from 'lucide-react';
import { Empty, LoadState } from '../ui';
import { ProductCard } from './ProductCard';

const ProductResults = ({ remote }) => {
  if (remote.loading || remote.error) return <LoadState remote={remote} />;
  if (!remote.data?.length) return <Empty title="No matching products" text="Try a different SKU or remove a filter." />;
  return <div className="product-grid catalog-grid">{remote.data.map(product => <ProductCard key={product.id} product={product} />)}</div>;
};

export const CatalogResults = ({ remote, query, clearQuery }) => <section className="catalog-results">
  <div className="results-meta">
    <span data-testid="catalog-result-count">{remote.loading ? 'Finding products…' : `${remote.data?.length || 0} products & services`}</span>
    {query && <button data-testid="clear-search-query" onClick={clearQuery}>“{query}” <X size={12} /></button>}
    <span className="muted">Wholesale prices for approved businesses</span>
  </div>
  <ProductResults remote={remote} />
</section>;